import logo from './logo.svg';
import './App.css';
import React, {useState} from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout/Layout'
import {Home} from "./components/Pages/Home/Home";

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route exact path="/" element={<Home authed={ true } />}/>
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
